/**
 * Part of rayband project.
 *
 * @copyright  Copyright (C) 2023 __ORGANIZATION__.
 * @license    __LICENSE__
 */

import { createApp } from 'vue';
import CombinationProductApp from '@/app/front/CombinationProductApp.vue';
import { AppPlugin } from '@/services/app-plugin';

S.import('@main')
  .then(() => u.domready())
  .then(() => {
      const app = createApp(CombinationProductApp);

      app.use(AppPlugin);
      app.mount('#combination-product-app');
    }
  );
